<template>
  <div class="w12">
    <asset-header></asset-header>
    <div class="w12 log-container">
      <div class="w12 padding-content">
        <div class="w12" flex fjb>
          <div class="w12 date-box" flex fjc>
            <el-date-picker class="w12 log-date-picker" v-model="dateRange" @change="setDate" :picker-options="pickerOptions" type="daterange" align="right" start-placeholder="0000-00-00" end-placeholder="0000-00-00"> </el-date-picker>
          </div>
          <div class="w12 select-box" flex fic>
            <!-- <select-js :data="selectDateList" class="select" :value="selectDate" @change="changeSelectDate" /> -->
            <select v-model="selectDate" @change="changeSelectDate($event)">
              <option v-for="(date, index) in selectDateList" :key="index" :value="date.value">{{ date.name }}</option>
            </select>
            <select v-model="remittanceType" @change="changeType($event)">
              <option value="">{{ $t("tradeLog.Total") }}</option>
              <option value="I">{{ $t("tradeLog.deposit") }}</option>
              <option value="O">{{ $t("tradeLog.withdrawal") }}</option>
            </select>
          </div>
        </div>
      </div>
      <send-log-list-krw v-if="activeCoin.code == 'KRW'" :active-coin="activeCoin" :list="historyList"></send-log-list-krw>
      <send-log-list-coin v-else :active-coin="activeCoin" :list="historyList"></send-log-list-coin>
      <div class="w12 ta-c mt20" v-if="lastList.length == 10">
        <button class="more" @click="more">
          {{ $t("main.more") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Moment from "moment";
import pagination from "vuejs-uib-pagination";
import Api from "@/common/Api";
import Bowser from "bowser";

import AssetHeader from "../component/asset/header";
import SendLogListKrw from "../component/asset/sendLogListKrw";
import sendLogListCoin from "../component/asset/sendLogListCoin";

export default {
  components: {
    AssetHeader,
    SendLogListKrw,
    sendLogListCoin,
  },
  data() {
    return {
      activeCoin: {},
      dateRange: [],
      list: [],
      coinCode: "",
      moment: Moment,
      selectDateList: [{ name: this.$t("tradeLog.today"), value: "1" }, { name: this.$t("tradeLog.1week"), value: "7" }, { name: this.$t("tradeLog.1month"), value: "30" }, { name: this.$t("tradeLog.3months"), value: "90" }],
      remittanceType: "",
      dateStart: Moment()
        .startOf("day")
        .add(-1, "days")
        .toDate(),
      dateEnd: Moment()
        .endOf("day")
        .toDate(),
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      historyList: [],
      lastList: [],
      countPerPage: 10,
      page: {},
      pagination: {
        numPages: 1000,
        currentPage: 1,
      },
      selectDate: "1",
    };
  },
  created() {
    this.dateRange = [this.dateStart, this.dateEnd];
  },
  async mounted() {
    this.activeCoin = this.coin[this.$route.params.coin];
    await this.setList();
  },
  computed: {
    ...mapGetters(["coin", "coinSettings", "markets"]),
    coinId() {
      return this.$route.params.coinName;
    },
    coinOptions() {
      return [
        { name: "전체", value: "ALL" },
        ..._.map(this.coinSettings, (coin) => {
          return {
            name: `${coin.name} (${coin.code})`,
            value: coin.code,
          };
        }),
      ];
    },
    durationDays() {
      return Moment.duration(Moment(this.dateEnd).startOf("day") - this.dateStart).as("d");
    },
    isAMonthAgo() {
      const ago = Moment(this.dateEnd)
        .subtract(1, "month")
        .startOf("day");
      return +this.dateStart === +ago;
    },
    is3MonthAgo() {
      const ago = Moment(this.dateEnd)
        .subtract(3, "months")
        .startOf("day");
      return +this.dateStart === +ago;
    },
  },
  methods: {
    more() {
      console.log(this.page.currentPage);
      this.addList(this.page.currentPage + 1);
    },
    setDate(val) {
      this.dateStart = Moment(val[0]).startOf("day");
      this.dateEnd = Moment(val[1]).endOf("day");
      this.setList();
    },
    changeSelectDate(event) {
      this.dateStart = Moment()
        .subtract(event.target.value, "days")
        .startOf("day");
      this.dateEnd = Moment().endOf("day");
      this.dateRange = [this.dateStart, this.dateEnd];
      this.selectDate = event.target.value;
      this.setList();
    },
    changePage() {
      this.setList({ page: this.page.currentPage });
    },
    changeType(event) {
      this.remittanceType = event.target.value;
      this.setList();
    },
    async addList(page) {
      const list = await this.getList({ page });
      this.historyList.push(...list);
    },
    async setList() {
      const list = await this.getList();
      this.historyList = list;
    },
    async getList(param = {}) {
      let marketId = 0;
      let params = {
        fromDate: Moment(this.dateStart).toISOString(),
        toDate: Moment(this.dateEnd).toISOString(),
        page: 1,
        count: 10,
        ...param,
      };

      // 검색 기간 1년 내로 제한
      if (Moment(this.dateEnd).diff(this.dateStart, "days") > 365) {
        this.$vs.notify({
          title: "안내",
          text:
            "최대 검색 기간은 1년입니다. 검색 기간을 다시 설정해 주세요.",
          position: "top-right",
        color: "danger",
        });
        return false;
      }

      let list = [];
      if (this.activeCoin.code == "KRW") {
        params.remittanceType = this.remittanceType;
        const res = await Api.Transfer.getKRWTransferHistory(params);
        this.pagination = { ...res.pagination };
        list = res.body;
      } else {
        params.transferType = this.remittanceType;
        params.coinId = this.activeCoin.id;
        const res = await Api.Transfer.getTransferHistory(params);
        this.pagination = { ...res.pagination };
        list = _.map(res.body, (row) => {
          return {
            ...row,
            coinName: this.activeCoin.code,
          };
        });
      }

      this.page.currentPage = params.page;
      // this.historyList = list;
      this.lastList = list;
      return list;
    },
  },
};
</script>

<style scoped lang="scss" src="./log.scss"></style>
